import React from 'react';



type Props = {
  className?: string;
}
export const CalendarVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M16 12H16.01' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M16 16H16.01' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M12 12H12.01' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M12 16H12.01' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M8 12H8.01' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M8 16H8.01' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M8 3V7' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M16 3V7' />
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M16 5H8C5.23858 5 3 7.23858 3 10V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V10C21 7.23858 18.7614 5 16 5Z' />
    </svg>
  );
};
